// extracted by mini-css-extract-plugin
module.exports = {"filterIcon":"featuredContent_filterIcon__3IAwB","filterIconContainer":"featuredContent_filterIconContainer__3OjFt","loading":"featuredContent_loading__7cpVT"};